import DefaultState from './DefaultState';
import ForecastGuidanceConfigurator from './ForecastGuidanceConfigurator';
import ForecastGuidancePreview from './ForecastGuidancePreview';

const index = {
    label: 'Forecast Guidance',
    type: 'forecastGuidance',
    defaultState: DefaultState,
    configurator: ForecastGuidanceConfigurator,
    preview: ForecastGuidancePreview,
};

export default index;
